export default function homeTabs(node: HTMLElement) {
  const buttons = node.querySelectorAll<HTMLButtonElement>('[data-tab-target]');
  const contents = node.querySelectorAll<HTMLElement>('[data-tab-content]');

  function scrollToActiveButton() {
    const activeButton = node.querySelector<HTMLButtonElement>(
      '[data-tab-target].is-active',
    );
    if (activeButton) {
      const parent = activeButton.parentElement;
      if (parent) {
        const nthButton = Array.from(buttons).indexOf(activeButton);
        const translateX =
          nthButton === 0
            ? 0
            : Math.max(0, parent.scrollWidth - parent.clientWidth);
        parent.scrollTo({ left: translateX, behavior: 'smooth' });
      }
    }
  }

  // Scroll to active button on load
  requestAnimationFrame(() => {
    scrollToActiveButton();
  });

  buttons.forEach((button) => {
    button.addEventListener('click', () => {
      const target = button.dataset.tabTarget;

      buttons.forEach((b) => {
        b.classList.remove('is-active');
      });
      button.classList.add('is-active');

      contents.forEach((content) => {
        content.classList.toggle(
          'is-hidden',
          content.dataset.tabContent !== target,
        );
      });

      // Scroll to active button on click
      scrollToActiveButton();
    });
  });
}
